export default __webpack_public_path__ + "static/media/image-integrations-google.fd01f9e1.png";